import { Controller } from "@hotwired/stimulus"

// Switches between DM and Group panels on the chat index page.
// Syncs the active tab to the URL query string so back/forward works.
export default class extends Controller {
  static targets = ["dmsPanel", "groupsPanel", "dmBtn", "groupBtn"]
  static values  = { active: { type: String, default: "dms" } }

  connect() {
    this._applyActive(this.activeValue)
  }

  showDms() {
    this._applyActive("dms")
    this._updateUrl("dms")
  }

  showGroups() {
    this._applyActive("groups")
    this._updateUrl("groups")
  }

  // -- private --

  _applyActive(tab) {
    const isDms = tab === "dms"

    if (this.hasDmsPanelTarget)    this.dmsPanelTarget.classList.toggle("hidden", !isDms)
    if (this.hasGroupsPanelTarget) this.groupsPanelTarget.classList.toggle("hidden", isDms)

    if (this.hasDmBtnTarget) {
      this.dmBtnTarget.classList.toggle("bg-white",    isDms)
      this.dmBtnTarget.classList.toggle("shadow-sm",   isDms)
      this.dmBtnTarget.classList.toggle("text-slate-800", isDms)
      this.dmBtnTarget.classList.toggle("text-slate-500", !isDms)
    }

    if (this.hasGroupBtnTarget) {
      this.groupBtnTarget.classList.toggle("bg-white",    !isDms)
      this.groupBtnTarget.classList.toggle("shadow-sm",   !isDms)
      this.groupBtnTarget.classList.toggle("text-slate-800", !isDms)
      this.groupBtnTarget.classList.toggle("text-slate-500", isDms)
    }
  }

  _updateUrl(tab) {
    const url = new URL(window.location)
    if (tab === "dms") {
      url.searchParams.delete("tab")
    } else {
      url.searchParams.set("tab", tab)
    }
    history.replaceState({}, "", url)
  }
}
